/* script */

import BaseResource from '../resources/base'
import { ResourceListField } from './ResourceList'

const __vue_script__ = {
    name: 'ResourceAttribute',
    props: {
        resource: {
            type: BaseResource,
            required: true,
        },
        attribute: {
            type: String,
            required: true,
        },
        currency: {
            type: [String, Boolean],
            default: false,
        },
        prepend: {
            type: String,
            default: '',
        },
        append: {
            type: String,
            default: '',
        },
        loadingText: {
            type: String,
            default: 'Loading...',
        },
        default: {
            type: String,
            default: '(None)',
        },
        linked: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        value() {
            if (this.loading) {
                return ''
            }

            try {
                let value = this.resource.get(this.attribute)

                if (value === undefined) {
                    value = this.default
                }

                if (this.currency) {
                    value = Number(value).toLocaleString('en-US', {
                        style: 'currency',
                        currency: this.currency,
                    })
                }

                return this.prepend + value + this.append
            } catch (e) {
                console.error(e)
                return '<error>'
            }
        },
        classes() {
            let classes = ['resource-attr']

            if (this.currency) {
                classes.push('currency')
            }

            return classes
        },
    },
    data() {
        return {
            loading: true,
        }
    },
    methods: {
        onClick() {
            this.$emit('click')
        },
    },
    async beforeMount() {
        try {
            await this.resource.resolveAttribute(this.attribute)
        } catch (e) {
            console.log(e)
        }
        this.loading = false
    },
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._t(
        "default",
        [
          !_vm.loading && _vm.linked
            ? _c("span", { class: _vm.classes }, [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:{}" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onClick($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.value))]
                )
              ])
            : !_vm.loading
            ? _c("span", { class: _vm.classes, on: { click: _vm.onClick } }, [
                _vm._v("\n            " + _vm._s(_vm.value) + "\n        ")
              ])
            : _c("span", { staticClass: "text-muted" }, [
                _vm._v(" " + _vm._s(_vm.loadingText) + " ")
              ])
        ],
        { value: _vm.value, loading: _vm.loading, resource: _vm.resource }
      )
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-087efc0c_0", { source: ".resource-attr.currency[data-v-087efc0c] {\n  font-family: \"Courier New\", sans-serif;\n  font-weight: 600;\n  display: block;\n  text-align: right;\n}\n\n", map: "AAiHA;EACA,sCAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAhHA;;AAEA,+CAA+C", media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-087efc0c"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "/src/components/ResourceAttribute.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/components/ResourceAttribute.js
// module id = nn5R
// module chunks = 0